import React, { useEffect } from "react";
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from './reportWebVitals';

// Note: Error suppression code is loaded from public/suppress-errors.js BEFORE this file
// This ensures CDN errors are caught before React and TinyMCE initialize

// Load Google Analytics gtag dynamically in production when REACT_APP_GA_ID is set.
// This avoids console errors when extensions block the request and allows disabling in local/dev.
(() => {
  try {
    const GA_ID = process.env.REACT_APP_GA_ID || process.env.REACT_APP_GA_MEASUREMENT_ID;
    const isProd = process.env.NODE_ENV === 'production';
    if (!GA_ID || !isProd) {
      window.gtag = window.gtag || function () { (window.dataLayer = window.dataLayer || []).push(arguments); };
      return;
    }

    if (window.gtag && window.gtag._loaded) return;

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    script.onload = () => {
      try {
        window.dataLayer = window.dataLayer || [];
        function gtag(){window.dataLayer.push(arguments);} 
        window.gtag = window.gtag || gtag;
        window.gtag('js', new Date());
        window.gtag('config', GA_ID);
        window.gtag._loaded = true;
      } catch (e) {
        // Suppress gtag errors
      }
    };
    script.onerror = () => {
      window.gtag = window.gtag || function () { (window.dataLayer = window.dataLayer || []).push(arguments); };
      window.gtag._loaded = false;
    };
    document.head.appendChild(script);
  } catch (err) {
    // Suppress GA loading errors
  }
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();

// Service Worker registration disabled
/*
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('✅ Service Worker registered successfully:', registration.scope);
        
        // Check for updates periodically
        setInterval(() => {
          registration.update().catch((error) => {
            console.log('Service Worker update check failed:', error);
          });
        }, 60000);
      })
      .catch((error) => {
        console.log('❌ Service Worker registration failed:', error);
      });
  });

  // Handle Service Worker updates
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    console.log('📦 New version available! Refresh to update.');
  });
}
*/

// Unregister any existing service workers
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (let registration of registrations) {
      registration.unregister().then((boolean) => {
        console.log('Service Worker unregistered:', boolean);
      });
    }
  });
}